import {
    IYandexMetrikaApi,
    IYandexMetrikaReachGoalHandler,
    IYandexMetrikaParamsHandler,
    IYandexMetrikaService,
    IYandexMetrikaServiceParams,
    YandexMetrikaMethods,
} from './types';

export class YandexMetrikaService implements IYandexMetrikaService {
    private metrikaApi: IYandexMetrikaApi;

    constructor({ metrikaApi }: IYandexMetrikaServiceParams) {
        this.metrikaApi = metrikaApi;
    }

    reachGoal: IYandexMetrikaReachGoalHandler = (...args) => {
        this.metrikaApi.emit({
            type: YandexMetrikaMethods.reachGoal,
            payload: args,
        });
    };

    params: IYandexMetrikaParamsHandler = (...args) => {
        this.metrikaApi.emit({
            type: YandexMetrikaMethods.params,
            payload: args,
        });
    };
}
